var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClearSmallicon = function SvgClearSmallicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.894 11.887a.357.357 0 0 1 0 .507l-.5.5a.357.357 0 0 1-.507 0L8 9.007l-3.887 3.887a.357.357 0 0 1-.507 0l-.5-.5a.357.357 0 0 1 0-.507L6.993 8 3.106 4.113a.357.357 0 0 1 0-.507l.5-.5a.357.357 0 0 1 .507 0L8 6.993l3.887-3.887a.357.357 0 0 1 .507 0l.5.5a.357.357 0 0 1 0 .507L9.007 8l3.887 3.887Z"
  })));
};
export default SvgClearSmallicon;